var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-action-foldout"},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"collapse-action-menu-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }